// A title counts as unreleased only when TMDB gives a parseable future date;
// titles with missing dates stay actionable so sparse entries aren't bricked.
// The API enforces the same rule on watch/comment writes.
export const getReleaseInfo = (dateText?: string | null) => {
  if (!dateText) return { unreleased: false, display: undefined }

  const date = new Date(dateText)
  if (isNaN(date.getTime())) return { unreleased: false, display: undefined }

  const today = new Date()
  today.setHours(0, 0, 0, 0)

  return {
    unreleased: date.getTime() > today.getTime(),
    display: date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }),
  }
}
